import { getGuide } from '@/graphql/queries/media/guide';
import lang from '@/lang/middleware/media';

export default async ({ $apolloQuery, app, redirect, route, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const category = route.params.category;
  const locale = route.query.locale;
  const slug = route.params.slug;
  await $apolloQuery(getGuide, { locale, slug }).then(guide => {
    if (guide.category !== category) {
      return redirect(app.localePath(`/guides/${guide.category}/${slug}/`));
    }
    const title = guide.meta_title || guide.headline;
    const description = guide.meta_description || guide.sub_title;
    store.commit('blog/setGuide', guide);
    store.commit('pageContent/SET_DYNAMIC_BREADCRUMBS', [
      ['i18n/home', '/'],
      ['i18n/guides', '/guides/'],
      [store.$i18n.t(`guides.categories.${guide.category}.name`), `/guides/${guide.category}/`],
      title
    ]);
    store.commit('pageContent/setHead', { description, title });
  }).catch(_ => redirect(app.localePath(`/guides/${category}/`)));
};
